import styled, { css } from 'styled-components';

export const Option = styled.div<{
  alreadyAnswered?: boolean;
  withSmallSize?: boolean;
  correct?: boolean;
  selectedAnswer?: boolean;
  compact?: boolean;
}>`
  flex: 1;
  font-family: ${({ theme }) => theme.fonts.citiSans};
  font-weight: 700;
  font-size: ${({ theme, withSmallSize, compact }) =>
    theme.getFontSize(withSmallSize || compact ? 22 : 25)};
  line-height: ${({ theme, withSmallSize, compact }) =>
    theme.getFontSize(withSmallSize || compact ? 26 : 30)};
  padding-inline: ${({ theme }) => theme.getValue(24)};
  padding-block: ${({ theme, compact }) => theme.getValue(compact ? 8 : 16)};
  border-color: transparent;
  border-style: solid;
  border-width: ${({ theme, compact }) => theme.getValue(compact ? 4 : 8)};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  min-height: ${({ theme, compact }) => theme.getValue(compact ? 120 : 180)};
  border-radius: ${({ theme }) => theme.getValue(30)};
  background-color: ${({ theme }) => theme.colors.white};
  box-sizing: border-box;
  ${({ alreadyAnswered, correct, theme, selectedAnswer }) => {
    if (alreadyAnswered) {
      if (selectedAnswer)
        return css`
          background-color: ${theme.colors.vividBlue};
          color: ${theme.colors.white};
        `;
      if (correct)
        return css`
          border-color: ${theme.colors.questionRight};
          color: ${theme.colors.answerGraySelected};
        `;
      return css`
        background-color: ${theme.colors.answerGray};
        color: ${theme.colors.answerGraySelected};
      `;
    }
    if (selectedAnswer) {
      return css`
        background-color: ${theme.colors.blue};
        color: ${theme.colors.white};
      `;
    }
    return css`
      cursor: pointer;
      color: ${theme.colors.black};
    `;
  }}
`;

export const Container = styled.div<{
  isLoading: boolean;
  disabled?: boolean;
  optionCount: number;
}>`
  width: 100%;
  height: 100%;
  max-height: ${({ theme }) => theme.getValue(1200)};
  max-width: ${({ theme }) => theme.getValue(1200)};
  margin-inline: auto;
  display: grid;
  grid-template-columns: ${({ optionCount }) => (optionCount <= 2 ? '1fr' : '1fr 1fr')};
  grid-auto-rows: 1fr;
  gap: ${({ theme, optionCount }) => theme.getValue(optionCount >= 5 ? 20 : 44)};
  padding-inline: ${({ theme, optionCount }) => theme.getValue(optionCount >= 5 ? 80 : 120)};
  padding-block: ${({ theme, optionCount }) => theme.getValue(optionCount >= 5 ? 4 : 8)};
  opacity: ${({ isLoading }) => (isLoading ? 0.7 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;
